"use strict";
var StorageBase = (function () {
    function StorageBase(storageLocation) {
        this.storageLocation = storageLocation;
        /**
         * Safari private mode does not have a storage provider. Of course,
         * this collection will be reset upon page refresh
         */
        this.memoryCache = {};
    }
    /**
     * Provided a string key, returns a string value from the storage location
     */
    StorageBase.prototype.getValue = function (key) {
        return this.getStringValue(key);
    };
    /**
     * Provided a type and a string key, returns a typed object from the storage location
     */
    StorageBase.prototype.getValueOfType = function (key) {
        var toReturn = null;
        var json = this.getStringValue(key);
        try {
            toReturn = JSON.parse(json);
        }
        catch (err) { }
        return toReturn;
    };
    /**
     * Provided a type and a string key, returns a type object from the storage location
     * Removes the object from the storage location
     */
    StorageBase.prototype.getOneTimeValue = function (key) {
        var value = this.getValueOfType(key);
        this.removeValue(key);
        return value;
    };
    /**
     * Provided a string key and string value, saves the value to session with the provided key
     */
    StorageBase.prototype.storeValue = function (key, value) {
        this.storeStringValue(key, value);
    };
    /**
     * Provided a type, string key and a typed value, encodes the value in JSON and saves it
     * to the storage location with the provided key
     */
    StorageBase.prototype.storeValueOfType = function (key, value) {
        if (key && value !== null && value !== undefined) {
            var json = JSON.stringify(value);
            this.storeStringValue(key, json);
        }
    };
    /**
     * Provided a string key, removes the key and value from the storage location
     */
    StorageBase.prototype.removeValue = function (key) {
        if (key) {
            if (this.storageLocation) {
                this.storageLocation.removeItem(key);
            }
            this.memoryCache[key] = undefined;
        }
    };
    StorageBase.prototype.getStringValue = function (key) {
        var returnValue = null;
        if (key) {
            if (this.storageLocation) {
                returnValue = this.storageLocation.getItem(key);
            }
            else {
                if (this.memoryCache.hasOwnProperty(key)) {
                    returnValue = this.memoryCache[key];
                }
            }
        }
        return returnValue;
    };
    StorageBase.prototype.storeStringValue = function (key, value) {
        if (key && value) {
            if (this.storageLocation) {
                this.storageLocation.setItem(key, value);
            }
            else {
                this.memoryCache[key] = value;
            }
        }
    };
    return StorageBase;
}());
exports.StorageBase = StorageBase;
//# sourceMappingURL=D:/a/1/s/base/src/storage-base.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/storage-base.service.js